module.exports = __webpack_public_path__ + "img/newlink.cfd2afb5.png";